export default __webpack_public_path__ + "static/media/home-chat.6226d4f1.jpg";